import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { useDropzone } from "react-dropzone";
import clsx from "clsx";
import Chat, {
  Bubble,
  useMessages,
  RichText,
  Button,
  Card,
  CardMedia,
  CardTitle,
  CardText,
  CardActions,
  Divider,
  Flex,
  Input,
  Icon,
  IconButton,
  Progress,
  List,
  ListItem,
  ScrollView,
} from "@chatui/core";
import "@chatui/core/dist/index.css";

import ChatRating from "./chat-rating";

import "../css/chat-window.css";
//import "../css/mobile-chat-window.css";

import {
  setSessionItem,
  getSessionItem,
  create_chat_logs,
  get_language,
  get_fontSize,
  csv_create_chat_logs,
  get_chatType,
} from "../utility/chatUtility";
import {
  update_lastMsg,
  time_since_lastMsg,
  set_timeOutFlag,
  get_timeOutFlag,
} from "../utility/timeoutUtility";
import {
  get_sessionID,
  get_quickReplies,
  make_request,
  make_warmup_request,
} from "../utility/dialogflowUtility";
import {
  createFive9WebSocket,
  sendFive9ChatMessage,
  WebSocketMessageHandler,
} from "../utility/five9Utility";
import {
  get_genesysID,
  createGenesysWebSocket,
} from "../utility/genesysUtility";

import { socketIOConnect } from "../utility/vaHubUtility";

import { io } from "socket.io-client";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton1 from "@mui/material/IconButton";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import RestartAlt from "@mui/icons-material/RestartAlt";
import xss from "xss";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import { alpha, styled } from "@mui/material/styles";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import ThumbDownOffAltIcon from "@mui/icons-material/ThumbDownOffAlt";
import KeyboardDoubleArrowDownRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowDownRounded";
import KeyboardDoubleArrowUpRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowUpRounded";
import Collapse from "@mui/material/Collapse";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";

import i18next from "i18next";
import { useTranslation } from "react-i18next";
import { Margin } from "@mui/icons-material";

// Messages added here will appear at the top of the chat window on load. Must be formatted the same as messages variable
var starterMessages = [];

const URLObj = window.URL || window.webkitURL;

// Check if message history exists in session storage, otherwise initialize session storage with default initial message
var initialMessages;
if (getSessionItem("msgHistory")) {
  initialMessages = JSON.parse(getSessionItem("msgHistory"));
} else {
  initialMessages = starterMessages;
  setSessionItem("msgHistory", JSON.stringify(initialMessages));
}

// Checks if quick replies exist in session storage. Otherwise initializes blank list of Quick Replies
var quickReplies = [];
if (getSessionItem("quickReplies")) {
  quickReplies = JSON.parse(getSessionItem("quickReplies"));
} else {
  setSessionItem("quickReplies", JSON.stringify(quickReplies));
}
// Check if unread message variable exist in session storage. Create with number 0 otherwise.
var unreadMsgNum = 0;
if (getSessionItem("unreadMsgNum")) {
  unreadMsgNum = JSON.parse(getSessionItem("unreadMsgNum"));
} else {
  setSessionItem("unreadMsgNum", JSON.stringify(unreadMsgNum));
}

// _____________________________________________Chat Window Component _______________________________________________________________________________________________________________________________________________________________________________
export default function ChatWindow(props) {
  let { messages, appendMsg, setTyping, deleteMsg, prependMsgs, resetList } = useMessages(initialMessages);
  const { env, openWindow, chatWindowStatus, setNewMsgNum } = props;
  const [lang, setLang] = useState(get_language(env.startingLanguage));
  const [fontSize, setFontSize] = useState(get_fontSize());
  const [ws, setWs] = useState(null);
  const [chatType, setChatType] = useState(get_chatType());
  const [socketIO, setsocketIO] = useState(null);
  const [socketName, setsocketName] = useState(null);
  const [userName, setUserName] = useState(null);
  const [status, setStatus] = useState(false);
  const [wsNum, setwsNum] = useState(null);
  const [langSubMenu, setLangSubMenu] = useState(false);
  const [fontSubMenu, setFontSubMenu] = useState(false);
  const [disclaimerSubMenu, setDisclaimerSubMenu] = useState(false);
  const [isFirstMessage, setIsFirstMessage] = useState(true);
  const [connectorConfig, setConnectorConfig] = useState(null);
  const [warmedUp, setWarmedUp] = useState(false);

  const { t, i18n } = useTranslation();

  if (window.screen.width < 500) {
    var isMobile = true;
  } else {
    var isMobile = false;
  }

  const DIALOGFLOW_START_INTENT = "asdjfj2398234hdfgnrsgou33234";

  useEffect(() => {
    if (sessionStorage.getItem("socketName")) {
      socketIOConnect(
        socketIO,
        setAnchorEl,
        sessionStorage.getItem("socketName"),
        setsocketIO,
        setsocketName,
        []
      );
    }

    if (env.connectorWebhook) {
      setSessionItem("connectorWebhook", env.connectorWebhook);
    }

    setConnectorConfig({
      "agentId": env.agentId,
      "projectId": env.projectId,
      "location": env.location,
      "environmentId": env.environmentId,
      "domain": env.domain
    });
  }, []);

  // Handles drag and drop for images
  const dropNotification = "Drop image inside chat window to upload";

  // Checks if maximum time since last reply from dialogflow has been exceeded. TimeOutFlag checks ensure that warning and termination messages are sent only once.
  function check_timeout() {
    // const warning_time = 3; // in seconds
    // const termination_time = 5;
    const warning_time = 300; // in seconds
    const termination_time = 420;
    var inactivity_time = time_since_lastMsg();

    if (
      inactivity_time >= warning_time &&
      inactivity_time < termination_time &&
      get_timeOutFlag() != "warned"
    ) {
      set_timeOutFlag("warned");
      appendMsg({
        type: "notification",
        content: {
          text: `${t("Session will end in 2 minutes due to inactivity")}`,
          time: createTimeStamp(),
        },
        position: "center",
      });
      unreadMsgIncrement();
    } else if (
      inactivity_time >= termination_time &&
      get_timeOutFlag() != "terminated"
    ) {
      set_timeOutFlag("terminated");
      quickReplies = get_quickReplies([]);
      appendMsg({
        type: "notification",
        content: {
          text: `${t("Chat session ended due to inactivity")}`,
          time: createTimeStamp(),
        },
        position: "center",
      });
      // socketIO.emit('send-chat-message', { type: "user-disconnect", recipient: sessionStorage.getItem("socketName"), time: Date.now() });
      if (socketIO) {
        socketIO.disconnect();
      }
      unreadMsgIncrement();
    } else {
      //console.log("get timeout flg=>", get_timeOutFlag());
    }
  }

  // Runs check_timeout periocically
  useEffect(() => {
    const interval = setInterval(() => {
      check_timeout();
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  // check for multiple queue update messages and delete old ones
  useEffect(() => {
    if (
      messages.length > 1 &&
      messages[messages.length - 1].type == "image" &&
      messages[messages.length - 2].type == "notification"
    ) {
      if (messages[messages.length - 2].content.text == dropNotification) {
        deleteMsg(messages[messages.length - 2]._id);
      }
    }
  }, [messages]);

  useEffect(() => {
    if (
      messages.length > 2 &&
      messages[messages.length - 1].type == "notification" &&
      messages[messages.length - 2].type == "notification"
    ) {
      // We can add more information to the message jsons later to allow us to differentiate queue updates without parsing the message. This works for now
      if (
        messages[messages.length - 1].content.text.endsWith("queue") &&
        messages[messages.length - 2].content.text.endsWith("queue")
      ) {
        deleteMsg(messages[messages.length - 2]._id);
      }
    }
  }, [messages]);

  // Delete queue status updates when agent connects
  useEffect(() => {
    // The latest message (length - 1) is the agent's first message
    // Handling this when we append that message would be better but I ran into trouble checking the conditions
    if (
      messages.length > 3 &&
      messages[messages.length - 1].type == "text" &&
      messages[messages.length - 2].type == "notification" &&
      messages[messages.length - 3].type == "notification"
    ) {
      // Check for the 2 notifications that exist before agent connection. Again, this isn't ideal but it works.
      if (
        messages[messages.length - 2].content.text.endsWith("queue") &&
        messages[messages.length - 3].content.text.endsWith("agent")
      ) {
        var agent_message = messages[messages.length - 1];
        for (var i = 1; i <= 3; i++) {
          deleteMsg(messages[messages.length - i]._id);
        }
        appendMsg({
          type: "notification",
          content: { text: "Connected to Genesys Agent" },
          position: "left",
        });
        // Seems like we can only append to the end of the array
        appendMsg(agent_message);
      }
    }
  }, [messages]);

  // sends invisible hello that initiates conversation on page load
  useEffect(() => {
    handleSend("welcomeMessage", "welcome");
  }, []);
  // GENESYS, Five9, or VAHub Websocket
  // Opens websocket and sends configuration message
  useEffect(() => {
    let isMounted = true;
    let wsConnection;

    if (isMounted) {
      if (
        chatType !== "genesys" &&
        chatType !== "five9" &&
        chatType !== "VAHub"
      )
        return;

      switch (chatType) {
        case "genesys":
          wsConnection = createGenesysWebSocket();
          break;
        case "five9":
          wsConnection = createFive9WebSocket();
          break;
        case "VAHub":
          wsConnection = socketIOConnect(
            socketIO,
            setAnchorEl,
            userName,
            setsocketIO,
            setsocketName,
            quickReplies
          );
          appendMsg({
            type: "divider",
            content: { text: "connectedSocketIO", time: createTimeStamp() },
            position: "center",
          });
          break;
      }

      setWs(wsConnection);
    }

    // Cleanup function
    return () => {
      isMounted = false;
      if (wsConnection && typeof wsConnection.close === "function") {
        wsConnection.close();
      }
    };
  }, [chatType]);

  // Appends responses from genesys to the chat window
  useEffect(() => {
    // don't do anything if the websocket isn't open yet
    if (!ws) return;
    console.log("chat type is: ", chatType);

    ws.onmessage = function (event) {
      if (chatType == "five9") {
        WebSocketMessageHandler(event, ws, appendMsg, messages);
      } else {
        var json = JSON.parse(event.data);
        console.log("event.data: ", JSON.stringify(event.data));
        console.log("json.body.connected: ", json.body.connected);
        console.log("messages: ", messages);

        // checks for message signifying session has been configured successfully
        if (json.class == "SessionResponse") {
          console.log("json.class == SessionResponse");

          if (json.body.connected === true) {
            console.log("messages: ", messages);
            // Generated formatted string with chat history and send to genesys agent as initial message
            const fetchData = async () => {
              const message_history = await create_chat_logs(messages);
              console.log("message_history: ", message_history);
              send_message(ws, message_history);
            };
            fetchData().catch(console.error);
          }
        }
        // filter out server status updates by checking for message text
        if (json.body.text) {
          var message = json.body.text;
          if (json.body.direction == "Outbound") {
            // only append messages recieved from genesys. Messages sent are appended in handleSend

            // bot messages appeneded as notifications rather than bubbles
            if (json.body.originatingEntity == "Bot") {
              appendMsg({
                type: "notification",
                content: { text: message, time: createTimeStamp() },
                position: "left",
              });
            } else {
              appendMsg({
                type: "text",
                content: { text: message },
                position: "left",
                user: {
                  avatar: (document.getElementById("favIcon").href =
                    "./img/genesys.svg"),
                },
              });
            }

            // reset time-out counter
            update_lastMsg();
            // handling for genesys session terminated by agent
            if (message.endsWith("have a great day!")) {
              // signals to generate new genesys token and that further messages should be sent to a new DF session
              setSessionItem("chatType", "genesysEnd");
              setChatType("genesysEnd"); // [f] why twice?
              setSessionItem("timeOutFlag", "terminated");
              appendMsg({
                type: "divider",
                content: { text: "agentEnd", time: createTimeStamp() },
                position: "center",
              });
            }
          }
        }
      }
    };
    // reruns when websocket state variable is updated
  }, [ws]);

  // sends message to genesys
  function send_message(ws, text) {
    ws.send(
      JSON.stringify({
        action: "onMessage",
        token: get_genesysID(),
        message: {
          type: "Text",
          text: text,
        },
      })
    );
  }

  // Redeclare username when websocket connection resets
  useEffect(() => {
    if (socketIO !== null) {
      socketIO.on("connect", () => {
        socketIO.emit("new-user", socketName, messages);
        //console.log("CONNECTED")
      });

      return () => {
        socketIO.off("connect");
      };
    }
  }, [socketIO, socketName]);

  useEffect(() => {
    if (socketIO !== null) {
      socketIO.on("user-disconnected", (data) => {
        appendMsg({
          type: "divider",
          content: { text: "disconnectedSocketIO", time: createTimeStamp() },
          position: "center",
        });
        if (socketIO) {
          socketIO.disconnect();
          setsocketIO(null);
          sessionStorage.removeItem("socketName");
        }
      });

      return () => {
        socketIO.off("user-disconnected");
      };
    }
  }, [socketIO]);

  useEffect(() => {
    if (socketIO !== null) {
      socketIO.on("chat-message", (data) => {
        if (data.type === "text") {
          appendMsg({
            type: "agentText",
            content: { text: data.message },
            position: "left",
            user: {
              avatar: (document.getElementById("favIcon").href =
                "./img/agent.png"),
            },
          });
        } else if (data.type === "image") {
          var url = URLObj.createObjectURL(
            new Blob([data.message], { type: "image/jpeg" })
          );
          //console.log(url)
          appendMsg({
            type: "image",
            content: { picUrl: url },
            position: "left",
            user: {
              avatar: (document.getElementById("favIcon").href =
                "./img/agent.png"),
            },
          });
        } else if (data.type === "webimage") {
          var url = data.message;
          appendMsg({
            type: "image",
            content: { picUrl: url },
            position: "left",
            user: {
              avatar: (document.getElementById("favIcon").href =
                "./img/agent.png"),
            },
          });
        }
      });

      return () => {
        socketIO.off("chat-message");
      };
    }
  }, [socketIO]);

  useEffect(() => {
    if (chatWindowStatus) {
      setSessionItem("unreadMsgNum", JSON.stringify(0));
      setNewMsgNum(0);
      updateBroswerTab(false);
    }
  }, [chatWindowStatus]);

  function handleDafaultStartSession() {
    let quickReplies;
    if (lang == "FR") {
      quickReplies = env.FR.quickReplies;
    } else {
      quickReplies = env.EN.quickReplies;
    }

    let welcomePrompt;
    if (lang == "FR") {
      welcomePrompt = " new prompt " + env.FR.welcomeMessage;
    } else {
      welcomePrompt = " new prompt " + env.EN.welcomeMessage;
    }

    return {
      prompt: welcomePrompt,
      quickReplies: quickReplies.split(","),
      cardTitle: [],
      cardsText: [],
      infoResponse: [],
    };
  }

  function hasTextContainsLink(text) {
    return /<a\b[^>]*>(.*?)<\/a>/i.test(text);
  }

  async function handleSend(type, val) {
    const avatarUrl = `https://storage.googleapis.com/${process.env.REACT_APP_ROOT_CSS_BUCKET}/avatars/${env.agentId}_${env.environmentId}.png?timestamp=${new Date().getTime()}`;

    // if user sends a message after termination send the message to a new session
    console.log({ val });
    console.log({ type });
    var DF_OutMsg = val;
    if (get_timeOutFlag() == "terminated" && type != "welcomeMessage") {
      resetConversation("true");
    }

    // Handle welcome message
    if (type === "welcomeMessage") {
      // Check if timeout flag is "warned" and number of messages is 3
      if (get_timeOutFlag() == "warned" && messages.length == 3) {
        resetConversation("false");
      }

      // Check if greetFlag is null
      if (getSessionItem("greetFlag") == null) {
        setSessionItem("greetFlag", "true");
        setTyping(true);
        setChatType("df");
        const response = handleDafaultStartSession();
        quickReplies = get_quickReplies(response.quickReplies);
        // 'hello' isn't displayed, only the response
        var prompt_list = split_prompt(response.prompt);
        // Append left-aligned text message
        appendMsg({
          type: "text",
          content: { text: prompt_list[0] },
          position: "left",
          user: {
            avatar: (document.getElementById("favIcon").href =
              avatarUrl),
          },
        });
        setTyping(false);
        unreadMsgIncrement();
        makeQuickReplies();
      }
    }
    if ((type === "text" || type === "boldtext") && val.trim()) {
      // handling for messages sent to genesys
      if (get_chatType() == "genesys") {
        send_message(ws, val);
        // append user's message to genesys
        appendMsg({
          type: "text",
          content: { text: val },
          position: "right",
        });
        setTyping(true);
        // Handling for messages sent to Custom Web App's socketIO
      } else if (get_chatType() == "socketIO") {
        socketIO.emit("send-chat-message", {
          type: "text",
          message: val,
          conversationId: socketName,
        });
        appendMsg({
          type: type,
          content: { text: val },
          position: "right",
        });

        // Handling for messages sent to Five9
      } else if (get_chatType() == "five9") {
        sendFive9ChatMessage(
          ws,
          val,
          sessionStorage.getItem("tokenId"),
          sessionStorage.getItem("farmId"),
          sessionStorage.getItem("sessionId"),
          sessionStorage.getItem("apiURL"),
          sessionStorage.getItem("extId")
        );

        appendMsg({
          type: type,
          content: { text: val },
          position: "right",
        });

        // Handling for messages sent to Dialogflow
      } else {
        // Append user message
        appendMsg({
          type: type,
          content: { text: val },
          position: "right",
        });

        // Hide old suggestion chips
        const elements = document.querySelectorAll(".QR");
        for (let i = 0; i < elements.length; i++) {
          elements[i].style.display = "none";
        }
        setTyping(true);
        // Get and append dialogflow response
        const sessionID = get_sessionID();
        if (isFirstMessage) {
          await make_request(
            DIALOGFLOW_START_INTENT,
            sessionID,
            lang,
            connectorConfig
          );
          setIsFirstMessage(false);
        }
        const response = await make_request(
          DF_OutMsg,
          sessionID,
          lang,
          connectorConfig
        );
        quickReplies = get_quickReplies(response.quickReplies);
        setTyping(false);
        console.log(response.prompt);
        if (response.exitState == "Transfer to agent") {
          setSessionItem("chatType", "genesys");
          // signals that websocket can be opened
          setChatType("genesys");
          quickReplies = get_quickReplies([]);

          // Append dividing line signaling connection to genesys
          appendMsg({
            type: "divider",
            content: { text: "agent", time: createTimeStamp() },
            position: "center",
          });

          //for five9 agent
        } else if (response.exitState == "Five9Agent") {
          //console.log('chattype is five9')
          setSessionItem("chatType", "five9");
          setChatType("five9");
          quickReplies = get_quickReplies([]);
          // send_message(ws, val)
          // Append dividing line signaling connection to genesys
          appendMsg({
            type: "divider",
            content: { text: "five9agent", time: createTimeStamp() },
            position: "center",
          });
          //for VA Hub agent
        } else if (response.exitState == "VAHub") {
          setSessionItem("chatType", "VAHub");
          // send transferring message to user before success connection
          console.log('sending "transfering to support agent"');
          appendMsg({
            type: "divider",
            content: { text: "socketIO", time: createTimeStamp() },
            position: "center",
          });
          setTyping(true);
          setChatType("VAHub");
          quickReplies = get_quickReplies([]);
          if (response && response["username"]) {
            setUserName(response["username"]);
          }
          // send_message(ws, val)
        } else if (
          response.infoResponse?.length === 4 &&
          response.infoResponse[0].length !== 0
        ) {
          let cardType = "scrollingListAddress";
          // response.infoResponse[1][0].indexOf("Address: ") == -1
          //   ? "linkList"
          //   : "scrollingListAddress";
          appendMsg({
            type: cardType,
            content: { text: response },
            position: "left",
            user: {
              avatar: (document.getElementById("favIcon").href =
                avatarUrl),
            },
          });
          unreadMsgIncrement();
        }
        // check if message contains a link
        else if (hasTextContainsLink(response.prompt)) {
          var prompt_list = split_prompt(response.prompt);
          appendMsg({
            type: "linkList",
            content: { text: prompt_list[0] },
            position: "left",
            user: {
              avatar: (document.getElementById("favIcon").href =
                avatarUrl),
            },
          });
          unreadMsgIncrement();
        } else {
          // chatType flag determines where messages are being sent
          var prompt_list = split_prompt(response.prompt);
          appendMsg({
            type: "text",
            content: { text: prompt_list[0] },
            position: "left",
            user: {
              avatar: (document.getElementById("favIcon").href =
                avatarUrl),
            },
          });
          unreadMsgIncrement();
          if (response.prompt.endsWith("Have a good day.")) {
            setSessionItem("timeOutFlag", "terminated");
            appendMsg({
              type: "divider",
              content: { text: "end", time: createTimeStamp() },
              position: "center",
            });
          }
        }
        // Append card if requisite information included included in DF response
        if (
          response.cardTitle.length !== 0 &&
          response.cardTitle.length == response.cardsText.length
        ) {
          appendMsg({
            type: "list",
            content: { text: response },
            position: "left",
            user: {
              avatar: (document.getElementById("favIcon").href =
                avatarUrl),
            },
          });
          unreadMsgIncrement();
          // Handling for operationg hours list
        } else if (
          response.cardTitle.length === 1 &&
          response.cardsText.length >= 1
        ) {
          appendMsg({
            type: "singleTitleList",
            content: { text: response },
            position: "left",
          });
          unreadMsgIncrement();
        }
        try {
          for (let i = 1; i < prompt_list.length; i++) {
            const prompt = prompt_list[i];
            if (prompt !== "") {
              appendMsg({
                type: hasTextContainsLink(prompt) ? "linkList" : "text",
                content: { text: prompt },
                position: "left",
                user: {
                  avatar: (document.getElementById("favIcon").href =
                    avatarUrl),
                },
              });
              unreadMsgIncrement();
            }
          }
        } catch (error) { }
      }
      if (quickReplies.length != 0) {
        makeQuickReplies();
      }

      // Deals with sending initial invisible hello on page load that brings up first DF message
    } else if (
      (type === "buttons" || type === "card" || type === "transactions") &&
      val.trim()
    ) {
      appendMsg({ type: type, content: { text: val }, position: "left" });
      unreadMsgIncrement();
    }
  }

  // splits raw prompt into multiple prompts that should be sent as different messages based on the split_signal
  function split_prompt(raw_prompt) {
    var prompt1 = "";
    var prompt2 = "";
    var prompt3 = "";
    var split_signal = " new prompt ";
    const errorMsgs = [undefined, null, "undefined", "null"];
    if (
      !raw_prompt ||
      errorMsgs.includes(raw_prompt) ||
      errorMsgs.includes(raw_prompt.split(split_signal).pop().trim())
    ) {
      prompt1 =
        "Sorry, I'm having a hard time connecting to the knowledge source, please try again later";
    } else {
      if (raw_prompt.search(split_signal) === 0) {
        var start_prompt = raw_prompt.substring(split_signal.length);
        var split_location = start_prompt.search(split_signal);
        if (split_location !== -1) {
          prompt1 = start_prompt.substring(0, split_location).trim();
          prompt2 = start_prompt.substring(
            split_location + split_signal.length
          );

          // check for remaining prompts
          var split_location_2 = prompt2.search(split_signal);
          if (split_location_2 !== -1) {
            prompt3 = prompt2.substring(split_location_2 + split_signal.length);
            prompt2 = prompt2.substring(0, split_location_2).trim();
          }
        } else {
          prompt1 = start_prompt;
        }
      }
    }
    return [prompt1, prompt2, prompt3];
  }

  function updateBroswerTab(newMsg = false) {
    if (newMsg) {
      document.getElementById("favIcon").href = "./img/red-chat.png";
    } else {
      document.getElementById("favIcon").href = "./img/black-chat.png";
    }
  }

  function unreadMsgIncrement() {
    if (!chatWindowStatus) {
      const currentUnread = JSON.parse(getSessionItem("unreadMsgNum"));

      setSessionItem("unreadMsgNum", JSON.stringify(Number(currentUnread) + 1));
      setNewMsgNum(Number(currentUnread) + 1);
      updateBroswerTab(true);
    }
  }

  function handleQuickReplyClick(item) {
    handleSend("text", item);
  }

  function makeQuickReplies() {
    var storedArray = JSON.parse(sessionStorage.getItem("quickReplies"));
    var i;
    var str = [];
    for (i = 0; i < storedArray.length; i++) {
      let x = (
        <button
          className="quickRepliesButton"
          onClick={() => handleQuickReplyClick(storedArray[i].name)}
        >
          {storedArray[i].name}
        </button>
      );
      str.push(storedArray[i].name);
    }
    appendMsg({
      type: "QR",
      content: { text: str },
      position: "left",
      altText: "Quick Replies",
    });
  }

  function createTimeStamp() {
    const d = new Date();
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear();
    const hours = d.getHours();
    var minutes = d.getMinutes();
    if (minutes < 10) {
      minutes = "0" + minutes;
    }
    const timeStamp =
      year + "-" + month + "-" + day + " " + hours + ":" + minutes;
    return timeStamp;
  }

  async function handleSendFeedback(msg, feedback) {
    let answer = "";
    if (getSessionItem("msgHistory")) {
      const msgHistory = JSON.parse(getSessionItem("msgHistory"));
      const questionIndex = msgHistory.findIndex(
        (historyMsg) => historyMsg.content.text === msg.content.text
      );
      const nextAnswer = msgHistory.find((historyMsg, index) => {
        return index > questionIndex && historyMsg.position === "right";
      });
      answer = nextAnswer ? nextAnswer.content.text : "";
    }
    const sessionID = get_sessionID();
    const makeRequestAction = "store_chat_feedback";
    const feedbackInputReq = {
      question: msg.content.text,
      conversationId: sessionID,
      feedback: feedback,
      answer: answer,
      timestamp: new Date().getTime(),
    };
    const response = await make_request(
      null,
      sessionID,
      lang,
      connectorConfig,
      makeRequestAction,
      feedbackInputReq
    );
    if (response && response["status"] === "success") {
      let colorChangerId =
        feedback === "positive" ? msg._id + "_Positive" : msg._id + "_Negative";
      colorChanger(colorChangerId);
    } else {
      console.error("Error sending feedback");
    }
  }

  function colorChanger(elementId) {
    let element = document.getElementById(elementId);
    let baseElement = elementId.split("_")[0];

    if (elementId.includes("Negative")) {
      element.style.color = element.style.color !== "red" ? "red" : "black";
      document.getElementById(baseElement + "_Positive").style.color = "black";
      document.getElementById(baseElement + "_Positive").style.opacity = "50%";
    }
    if (elementId.includes("Positive")) {
      element.style.color = element.style.color !== "green" ? "green" : "black";
      document.getElementById(baseElement + "_Negative").style.color = "black";
      document.getElementById(baseElement + "_Negative").style.opacity = "50%";
    }

    element.style.opacity = element.style.color !== "black" ? "100%" : "50%";
  }

  const renderFeedbackButtons = (msg, contentText, type) =>
  (
    <Box className="feedbackContainer">
      <Button
        id={msg._id + "_Positive"}
        onClick={() => handleSendFeedback(msg, "positive")}
        aria-label="Positive feedback"
      >
        <ThumbUpOffAltIcon fontSize="small" />
      </Button>
      <Button
        id={msg._id + "_Negative"}
        onClick={() => handleSendFeedback(msg, "negative")}
        aria-label="Negative feedback"
      >
        <ThumbDownOffAltIcon fontSize="small" />
      </Button>
    </Box>
  );

  function BoldText({ children }) {
    return <strong>{children}</strong>;
  }

  /*
  Formats response.

  URL parsing uses regex patterns:

  1. \[.*?:\s*https?:\/\/[^\s]+\]
  - \[: Matches the opening square bracket [.
  - .*?: Matches any character (except for line terminators), between zero and unlimited times, as few times as possible (non-greedy).
  - :: Matches the colon character :.
  - \s*: Matches any whitespace character (spaces, tabs, line breaks), zero or more times.
  - https?:\/\/: Matches http:// or https://.
  - [^\s]+: Matches any character except for whitespace, one or more times.
  - \]: Matches the closing square bracket ].
  
  2. \[\/[^\]]+\]
  - \[: Matches the opening square bracket [.
  - \/: Matches the literal slash character /.
  - [^\]]+: Matches any character except for the closing square bracket ], one or more times.
  - \]: Matches the closing square bracket ].
  
  3. \[https?:\/\/[^\s]+\]
  - \[: Matches the opening square bracket [.
  - https?:\/\/: Matches http:// or https://.
  - [^\s]+: Matches any character except for whitespace, one or more times.
  - \]: Matches the closing square bracket ].
  */
  function formatText(text) {
    const sections = text.split(/## (.*?)\n\n/g);

    let formattedContent = sections.map((part, index) => {
      if (index % 2 === 1) {
        return <h3 key={index}>{part}</h3>;
      }

      const textWithoutHeaders = part.replace(/##/g, "");

      // Split into parts based on strings enclosed in square brackets
      const parts = textWithoutHeaders.split(/(\[.*?\])/g);

      // Combine text and link elements
      const formattedParts = parts.map((subpart, subIndex) => {
        if (subIndex % 2 === 1) {
          // Handle each case based on the pattern
          if (subpart.startsWith("[")) {
            // Remove the enclosing square brackets
            const innerText = subpart.slice(1, -1);

            // Case: [https://www.anywebsite.com/product]
            if (
              innerText.startsWith("http://") ||
              innerText.startsWith("https://")
            ) {
              return (
                <a
                  key={subIndex}
                  href={innerText}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="product-link"
                >
                  {`link`}
                </a>
              );
            }

            // Case: [/link1/link2]
            if (innerText.startsWith("/")) {
              const url = `${process.env.REACT_APP_WEBSITE_DOMAIN}${innerText}`;
              return (
                <a
                  key={subIndex}
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="service-link"
                >
                  {`link`}
                </a>
              );
            }

            // Case: [Description: URL]
            if (innerText.includes(":")) {
              const all = innerText.split(":");
              const text = all.shift();
              const url = all.join(":").trim();
              if (url.trim().startsWith("/")) {
                const fullUrl =
                  process.env.REACT_APP_WEBSITE_DOMAIN + url.trim();
                return (
                  <a
                    key={subIndex}
                    href={fullUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-description"
                  >
                    {`${text}`}
                  </a>
                );
              } else if (url.trim().startsWith("link to")) {
                const urlOnly = url.split("link to")[1].trim();
                if (
                  urlOnly.startsWith("http://") ||
                  urlOnly.startsWith("https://")
                ) {
                  return (
                    <a
                      key={subIndex}
                      href={urlOnly}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-description"
                    >
                      {`${text}`}
                    </a>
                  );
                } else if (urlOnly.startsWith("/")) {
                  const fullUrl =
                    process.env.REACT_APP_WEBSITE_DOMAIN + urlOnly;
                  return (
                    <a
                      key={subIndex}
                      href={fullUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-description"
                    >
                      {`${text}`}
                    </a>
                  );
                } else {
                  const fullUrl =
                    process.env.REACT_APP_WEBSITE_DOMAIN + "/" + urlOnly;
                  return (
                    <a
                      key={subIndex}
                      href={fullUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="link-description"
                    >
                      {`${text}`}
                    </a>
                  );
                }
              } else {
                return (
                  <a
                    key={subIndex}
                    href={url.trim()}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-description"
                  >
                    {`${text}`}
                  </a>
                );
              }
            }

            // If no cases matched, just return the innerText
            return `${innerText}`;
          }
        } else {
          // Text part
          // Handle bold text within regular text
          return subpart.split("**").map((boldPart, boldIndex) => {
            if (boldIndex % 2 === 1) {
              return <BoldText key={boldIndex}>{boldPart}</BoldText>;
            } else {
              return boldPart.replace(/\*/g, "•");
            }
          });
        }
      });

      return formattedParts;
    });

    return formattedContent;
  }

  function renderMessageContent(msg) {
    const { type, content, position } = msg;
    // update session storage if the message list has changed
    if (!(getSessionItem("msgHistory") == JSON.stringify(messages))) {
      initialMessages = messages;
      setSessionItem("msgHistory", JSON.stringify(messages));
    }
    // Check if ai generated
    var isAiGenerated = false;
    if (content.text.includes("***AIDISCLAIMER***")) {
      isAiGenerated = true;
    }
    // handling for different values of type sent in appendMsg()
    switch (type) {
      case "boldtext":
        var html = `<h2>${content.text}</h2>`;
        return <Bubble content={<RichText content={html} />} />;
      case "text":
      case "agentText":
        if (position == "left") {
          let agentMsg = content.text;
          let disclaimerMsg;
          // Format AI disclaimer
          if (isAiGenerated === true) {
            disclaimerMsg = agentMsg.split("***AIDISCLAIMER***")[0];
            agentMsg = agentMsg.split("***AIDISCLAIMER***")[1];
          }

          if (agentMsg.includes("***---ANSWER_SUMMARY_SEPARATOR---***")) {
            const [showFullAnswer, setShowFullAnswer] = useState(false);
            const separator = "\n\n***---ANSWER_SUMMARY_SEPARATOR---***\n\n";
            const separated_answers = agentMsg.split(separator);
            separated_answers[0] = formatText(separated_answers[0]);
            separated_answers[1] = formatText(separated_answers[1]);
            return (
              <div className="botResponse">
                <Box className="textBubble_left">
                  {isAiGenerated && (
                    <div className="ai-disclaimer">
                      <img src="./img/google-gemini-icon.png" alt="icon" />
                      {disclaimerMsg}
                    </div>
                  )}
                  {separated_answers[1]} {/* Summary - always visible */ "\n\n"}
                  <Divider />
                  <Collapse in={showFullAnswer}>
                    {/* <Card className="expand-card">
                      <CardText>{separated_answers[0]} </CardText>
                    </Card> */}
                    <Box className="expand-card">{separated_answers[0]}</Box>
                  </Collapse>
                  {showFullAnswer && ( // Show collapse button only when expanded
                    <IconButton1
                      sx={{ margin: 0.5 }}
                      className="read-more-button"
                      onClick={() => setShowFullAnswer(false)}
                    >
                      <KeyboardDoubleArrowUpRoundedIcon />
                    </IconButton1>
                  )}
                  {!showFullAnswer &&
                    separated_answers[0] && ( // Show "Read More" when collapsed
                      <IconButton1
                        sx={{ margin: 0.5, fontSize: "15px" }}
                        className="read-more-button"
                        onClick={() => setShowFullAnswer(true)}
                      >
                        {t("Read More")} <KeyboardDoubleArrowDownRoundedIcon />
                      </IconButton1>
                    )}
                </Box>
                {isAiGenerated && renderFeedbackButtons(msg, agentMsg, type)}
              </div>
            );
          }

          const formattedContent = formatText(agentMsg);

          return (
            <div className="botResponse">
              <Box className="textBubble_left">
                {isAiGenerated && (
                  <div className="ai-disclaimer">
                    <img src="./img/google-gemini-icon.png" alt="icon" />
                    {disclaimerMsg}
                  </div>
                )}
                {formattedContent}
              </Box>
              {isAiGenerated && renderFeedbackButtons(msg, agentMsg, type)}
            </div>
          );
        } else {
          return (
            <Box className="textBubble_right" content={content.text}>
              {content.text}
            </Box>
          );
        }

      case "image":
        return (
          <Bubble type="image">
            <img
              className="chat-image"
              src={content.picUrl}
              alt={`chat-image-${content.picUrl}`}
              onClick={() => {
                window.open(content.picUrl);
              }}
              style={{ cursor: "pointer" }}
            />
          </Bubble>
        );
      case "card":
        return (
          // Sample card rendering for testing purposes
          <Card size="lg">
            <CardMedia image="//gw.alicdn.com/tfs/TB1Xv5_vlr0gK0jSZFnXXbRRXXa-427-240.png" />
            <CardTitle>Card Title</CardTitle>
            <CardText>{content.text}</CardText>
            <CardActions>
              <Button onClick={update_lastMsg} alt="Default button">
                Default button
              </Button>
              <Button color="primary" alt="Primary button">
                Primary button
              </Button>
            </CardActions>
          </Card>
        );
      case "buttons":
        return (
          // Button bound to reset chat. This will be moved to the taskbar.
          <div className="demo-btn">
            {content.text.map((label, index) => (
              <Button
                key={index}
                onClick={() => resetConversation("button")}
                alt={label}
              >
                {label}
              </Button>
            ))}
          </div>
        );

      // List without clickable links
      case "list":
        const items = [];
        for (var i = 0; i < content.text.cardTitle.length; i++) {
          items.push(
            <ListItem>
              <strong>{content.text.cardTitle[i]}</strong>
              <br></br>
              {content.text.cardsText[i]}
            </ListItem>
          );
        }

        return <List>{items}</List>;
      // List for operating hours
      case "singleTitleList":
        const textItems = [];
        textItems.push(
          <ListItem>
            <strong>{content.text.cardTitle[0]}</strong>
          </ListItem>
        );
        for (var i = 0; i < content.text.cardsText.length; i++) {
          textItems.push(<ListItem>{content.text.cardsText[i]}</ListItem>);
        }

        return <List>{textItems}</List>;

      // Grey text without bubble used for genesys bot notifications
      case "notification":
        if (content.time) {
          return (
            <div className="timeDiv">
              {content.time}
              <br></br>
              <in-window-notification>{content.text}</in-window-notification>
            </div>
          );
        } else {
          return (
            <Divider>
              <in-window-notification>{content.text}</in-window-notification>
            </Divider>
          );
        }

      // List with clickable links
      case "linkList":
        const openInNewTab = (url) => {
          window.parent.postMessage({ type: "openUrl", data: url }, "*");
        };

        function splitStringWithAnchor(text) {
          const regex = /<a\s+href\s*=\s*['"]([^'"]+)['"]>([^<]+)<\/a>/g;
          const result = [];
          let lastIndex = 0;
          let match;

          while ((match = regex.exec(text)) !== null) {
            const prompt = text.substring(lastIndex, match.index);
            const link = match[1];
            const linkText = match[2];

            if (prompt) {
              result.push({ prompt });
            }

            result.push({ prompt: linkText, link });

            lastIndex = regex.lastIndex;
          }

          const remainingPrompt = text.substring(lastIndex);
          if (remainingPrompt) {
            result.push({ prompt: remainingPrompt });
          }

          return result;
        }
        const promptLinks = splitStringWithAnchor(content.text);
        return (
          <div className="botResponse">
            {content.text.length > 0 && ( // Wrap the entire conditional rendering in parentheses
              <Box className="textBubble_left">
                {promptLinks.map((eachPrompt, index) => {
                  const key = `${index}-${eachPrompt.link ? eachPrompt.link : "no-link"
                    }`;
                  if (eachPrompt.link) {
                    return (
                      <a
                        className="linkList"
                        key={key}
                        onClick={() => openInNewTab(eachPrompt.link)}
                      >
                        {eachPrompt.prompt}
                      </a>
                    );
                  } else {
                    return <span key={key}>{eachPrompt.prompt}</span>;
                  }
                })}
              </Box>
            )}
            {isAiGenerated && renderFeedbackButtons(msg, content.text, type)}
          </div>
        );

      // scrolling list with clickable links
      case "scrollingListAddress":
        let listItems = [];
        let linkURL = (url) => {
          window.open(url, "_blank", "noopener, noreferrer");
        };

        for (var i = 0; i < content.text.infoResponse[0].length; i++) {
          let url = content.text.infoResponse[2][i];
          let message = content.text.infoResponse[1][i];
          const addressIndex = message.indexOf("Address: ");
          const telephoneIndex = message.indexOf("Telephone: ");
          const address = message
            .substring(addressIndex + "Address: ".length, telephoneIndex)
            .trim();
          const telephone = message
            .substring(telephoneIndex + "Telephone: ".length)
            .trim();
          listItems.push(
            <ListItem
              href="#"
              onClick={() => linkURL(url)}
              class="scrollableList"
            >
              <img
                src={content.text.infoResponse[3][i]}
                alt="scrollingListAddress"
                style={{
                  height: "100px",
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                  minWidth: "50%",
                  maxWidth: "100%",
                  objectFit: "cover",
                }}
              />

              <strong
                style={{ top: "120px", position: "absolute", left: "10px" }}
              >
                {content.text.infoResponse[0][i]}
              </strong>
              <p
                style={{
                  margin: "0",
                  position: "absolute",
                  top: "175px",
                }}
              >
                {address}
              </p>
              <p style={{ position: "absolute", bottom: "0px" }}>{telephone}</p>
            </ListItem>
          );
        }

        // return <List>{listItems}</List>;
        return (
          <ScrollView
            data={listItems}
            renderItem={(item) => <List>{item}</List>}
          />
        );

      // dividing lines with hard coded messages used on chat reset and genesys connect/disconnect
      case "divider":
        let breakMessage = "";
        // status field determines line color
        if (content.text == "reset") {
          breakMessage = `${t("New Chatbot Session")}`;
          return (
            <div>
              <div className="timeDiv">{content.time}</div>
              <br></br>
              <in-window-notification>{breakMessage}</in-window-notification>
              <div className="notificationDivider"></div>
            </div>
          );
        } else if (content.text == "agent") {
          breakMessage = "Transferring To Genesys Agent";
          return sessionBreak(breakMessage, content.time);
        } else if (content.text == "five9agent") {
          breakMessage = "Transferring To Five9 Agent";
          return sessionBreak(breakMessage, content.time);
        } else if (content.text == "socketIO") {
          breakMessage = "Transferring To Support Agent";
          return sessionBreak(breakMessage, content.time);
        } else if (content.text == "agentEnd") {
          breakMessage = "Agent Ended Session";
          return sessionEnd(breakMessage, content.time);
        } else if (content.text == "Five9AgentAccepted") {
          breakMessage = `${content.agentName} joined the chat`;
          return agentStatus(breakMessage);
        } else if (content.text == "Five9AgentLeft") {
          breakMessage = `${content.agentName} left the chat`;
          return agentStatus(breakMessage);
        } else if (content.text == "Five9AgentTransfer") {
          breakMessage = "Transferring To Another Agent";
          return sessionBreak(breakMessage, content.time);
        } else if (content.text == "Five9GroupTransfer") {
          breakMessage = "Transferring To Another Agent";
          return sessionBreak(breakMessage, content.time);
        } else if (content.text == "connectedSocketIO") {
          messages.forEach((msg, index) => {
            if (msg.type === "divider" && msg.content.text === "socketIO") {
              deleteMsg(msg._id);
            }
          });
          breakMessage = `${t("Connected To Support Agent")}`;
          return sessionBreak(breakMessage, content.time);
        } else if (content.text == "disconnectedSocketIO") {
          breakMessage = `${t("Disconnected From Support Agent")}`;
          // return ChatRating();
          return sessionBreak(breakMessage, content.time);
        } else {
          breakMessage = "Chat Ended Session";
          return sessionBreak(breakMessage, content.time);
        }
      case "QR":
        const itemList = [];
        if (process.env.REACT_APP_CHIPS_FORMAT == "stacked") {
          /* This one for list of options in larger boxes */
          for (var i = 0; i < content.text.length; i++) {
            const postLink = content.text[i];
            itemList.push(
              <Box
                className="quickReplyBox"
                key={i}
                onClick={() => handleQuickReplyClick(postLink)}
              >
                {content.text[i]}
              </Box>
            );
          }
        } else if (process.env.REACT_APP_CHIPS_FORMAT == "links") {
          for (var i = 0; i < content.text.length; i++) {
            const postLink = content.text[i];
            itemList.push(
              <ListItem
                className="quickRepliesButton"
                key={i}
                onClick={() => handleQuickReplyClick(postLink)}
              >
                {content.text[i]}
              </ListItem>
            );
          }
        }
        //
        // for grouped boxes put in return -> <div className="quickReplyDiv"> {itemList}</div>
        return <div className="QR">{itemList}</div>;

      default:
        return null;
    }
  }

  function sessionBreak(breakMessage, time) {
    return (
      <div>
        <div className="timeDiv">{time}</div>
        <br></br>
        <b className="sessionBreakContainer">{breakMessage}</b>
        <div>
          {breakMessage === "Disconnected From Support Agent" && (
            <ChatRating handleSetRating={handleSetRating} />
          )}
        </div>
        <Progress value={100} status="success" />
      </div>
    );
  }

  async function handleSetRating(props) {
    const sessionID = get_sessionID();
    const chatRatingReq = {
      ...props,
      conversationId: sessionID,
      timestamp: new Date().getTime(),
    };
    const makeRequestAction = "store_chat_rating";
    const response = await make_request(
      null,
      sessionID,
      lang,
      connectorConfig,
      makeRequestAction,
      chatRatingReq
    );
    resetChat();
    return response;
  }
  function agentStatus(breakMessage) {
    return (
      <div>
        <Divider>
          <h3>{breakMessage}</h3>
        </Divider>
      </div>
    );
  }
  function sessionEnd(breakMessage, time) {
    return (
      <div>
        <div className="timeDiv">{time}</div>
        <br></br>
        <b>{breakMessage}</b>
        <br></br>
        <small>To start a new chat, just type in a message!</small>
        <Progress value={100} status="active" />
      </div>
    );
  }

  // Starts a new dialogflow session. Will delete message history if keepHistory is false
  function resetConversation(keepHistory = "false") {
    if (getSessionItem("chatType") == "genesys") {
      return;
    }

    if (keepHistory == "false") {
      // delete history and restore initial messages
      for (const message of messages) {
        deleteMsg(message._id);
      }
      prependMsgs(starterMessages);
      initialMessages = messages;
      setSessionItem("msgHistory", JSON.stringify(messages));
      // Causes invisible hello to be sent. DF responds strarting conversation
      sessionStorage.removeItem("greetFlag");
      // triggers if a user sends a message after chat termination
    } else if (keepHistory == "true") {
      appendMsg({
        type: "divider",
        content: { text: "reset", time: createTimeStamp() },
        position: "center",
      });
    } else if (keepHistory == "button") {
      appendMsg({
        type: "divider",
        content: { text: "reset", time: createTimeStamp() },
        position: "center",
      });
      // triggers the greeting if user presses reset button
      sessionStorage.removeItem("greetFlag");
    }

    // Only start a new genesys session if the agent has terminated the previous session
    if (getSessionItem("chatType") == "genesysEnd") {
      sessionStorage.removeItem("genesysID");
    }
    // clear quick replies
    quickReplies = [];
    setSessionItem("quickReplies", quickReplies);
    sessionStorage.removeItem("sessionId");
    sessionStorage.removeItem("lastMsgTime");
    sessionStorage.removeItem("timeOutFlag");
    sessionStorage.removeItem("chatType");

    // Reset Messages
    resetList();

    setSessionItem("unreadMsgNum", JSON.stringify(0));
    setIsFirstMessage(true);
    if (socketIO) {
      socketIO.disconnect();
      setsocketIO(null);
      setsocketName(null);
      sessionStorage.removeItem("socketName");
    }
  }

  // For Slider
  function handleLanSelect(language) {
    var langToPrint;
    var newLang;
    if (language == "FR") {
      langToPrint = "English";
      newLang = "EN";
    } else {
      langToPrint = "Français";
      newLang = "FR";
    }
    setLang(newLang);
    setSessionItem("language", newLang);

    if (language !== newLang) {
      appendMsg({
        type: "notification",
        content: { text: `${t("Language changed to")} + " " + ${langToPrint}` },
        position: "left",
      });
    } else {
      appendMsg({
        type: "notification",
        content: {
          text: `${t("Language is already set to")} + " " +  ${langToPrint}`,
        },
        position: "left",
      });
      // return checked;
    }

    quickReplies = [];
    setSessionItem("quickReplies", quickReplies);
    setAnchorEl2(null);
    setAnchorEl(null);
    setIconOpen(false);
  }

  function handleFontPicker(size) {
    setFontSize(size);

    // Change the displayed selected font size within the settings menu
    let element = document.getElementById("fontSelectionDisplay");
    element.textContent = size;

    let cssRoot = document.querySelector(":root");

    switch (size) {
      case "Small":
        cssRoot.style.setProperty("--font-size-1", "16px");
        cssRoot.style.setProperty("--font-size-2", "14px");
        cssRoot.style.setProperty("--font-size-3", "12px");
        cssRoot.style.setProperty("--button-size-1", "2.25em");
        break;
      case "Medium":
        if (window.innerWidth < 700) {
          cssRoot.style.setProperty("--font-size-1", "18px");
        } else {
          cssRoot.style.setProperty("--font-size-1", "18px");
        }
        cssRoot.style.setProperty("--font-size-2", "16px");
        cssRoot.style.setProperty("--font-size-3", "14px");
        cssRoot.style.setProperty("--button-size-1", "2.5em");
        break;
      case "Large":
        if (window.innerWidth < 700) {
          cssRoot.style.setProperty("--font-size-1", "20px");
        } else {
          cssRoot.style.setProperty("--font-size-1", "20px");
        }
        cssRoot.style.setProperty("--font-size-2", "18px");
        cssRoot.style.setProperty("--font-size-3", "16px");
        cssRoot.style.setProperty("--button-size-1", "3em");
        break;
    }

    setAnchorEl(null);
    setIconOpen(false);
    setLangSubMenu(false);
    setFontSubMenu(false);
    setDisclaimerSubMenu(false);
  }

  // For Select through Settings
  function handleLanguagePicker(language) {
    var langToPrint;
    var newLang = language;
    var currentLang = getSessionItem("language");

    // Change the displayed selected language within the settings menu
    let element = document.getElementById("languageSelectionDisplay");
    element.textContent = language;

    switch (language) {
      case "EN":
        langToPrint = "English";
        break;
      case "FR":
        langToPrint = "Français";
        break;
      case "AUTO":
        langToPrint = "Auto";
        break;
    }

    setLang(newLang);
    setSessionItem("language", newLang);

    console.log("changing language to: ", language);
    i18next.changeLanguage(language);

    if (currentLang !== newLang) {
      appendMsg({
        type: "notification",
        content: { text: `${t("Language changed to")} ${langToPrint}` },
        position: "left",
      });
    } else {
      appendMsg({
        type: "notification",
        content: { text: `${t("Language is already set to")} ${langToPrint}` },
        position: "left",
      });
      // return checked;
    }

    // Set i18n to new language

    quickReplies = [];
    setSessionItem("quickReplies", quickReplies);
    // setAnchorEl2(null);
    setAnchorEl(null);
    setIconOpen(false);
    setLangSubMenu(false);
    setFontSubMenu(false);
    setDisclaimerSubMenu(false);
  }

  function downloadTranscript() {
    // Get today's date
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    var filename = "Transcript " + mm + "_" + dd + "_" + yyyy;

    var text = csv_create_chat_logs(messages, env);

    // Creating element to allow for Click to download transcript
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }

  // Expands the Language
  function openLanguageSubmenu() {
    setLangSubMenu(!langSubMenu);
  }

  // Expands the Font size Menu
  function openFontSubmenu() {
    setFontSubMenu(!fontSubMenu);
  }

  // Expands the Disclaimer Menu
  function openDisclaimerSubmenu() {
    console.log(messages);
    setDisclaimerSubMenu(!disclaimerSubMenu);
  }

  function handleImagePaste(e) {
    var item = e.clipboardData.items[0];
    // Handling for copy-pasting local image
    if (item.type.indexOf("image") === 0) {
      var blob = item.getAsFile();
      var url = URLObj.createObjectURL(blob);
      appendMsg({ type: "image", content: { picUrl: url }, position: "right" });
      if (get_chatType() == "socketIO") {
        socketIO.emit("send-chat-message", { type: "image", message: blob });
      }
      // Handling for copy-pasting web image
    } else if (item.type.indexOf("text/html") === 0) {
      var dataHTML = e.clipboardData.getData("text/html");

      var parser = new DOMParser();
      var htmlDoc = parser.parseFromString(dataHTML, "text/html");
      var link = htmlDoc.getElementsByTagName("img")[0].src;
      appendMsg({
        type: "image",
        content: { picUrl: link },
        position: "right",
      });
      if (get_chatType() == "socketIO") {
        socketIO.emit("send-chat-message", { type: "webimage", message: link });
      }
    }
  }

  // Brings dropzone div to the front when file is being dragged
  function activateDropzone(e) {
    //console.log(e)
    document.getElementById("dropper").style.zIndex = 3;
    if (
      messages[messages.length - 1].content.text !== dropNotification &&
      messages[messages.length - 1].type !== "notification"
    ) {
      appendMsg({
        type: "notification",
        content: { text: dropNotification },
        position: "left",
      });
    }
  }
  // Handles situations where dropzone is activated but file is not dropped/supported
  function deactivateDropzone() {
    if (
      messages[messages.length - 1].type == "notification" &&
      messages[messages.length - 1].content.text == dropNotification
    ) {
      deleteMsg(messages[messages.length - 1]._id);
    }
    document.getElementById("dropper").style.zIndex = -1;
  }

  function handleSanitizeSend(type, message) {
    if (type === "text") {
      var sanitized = xss(message);
      handleSend("text", sanitized);
    }
  }

  const InputContainer = () => {
    const [typeMessage, setTypeMessage] = useState("");

    const switchClick = () => {
      handleLanSelect(sessionStorage.getItem("language"));
      var lang = sessionStorage.getItem("language");
      if (lang == "EN") {
        setStatus(false);
      } else {
        setStatus(true);
      }
    };

    const GreenSwitch = styled(Switch)(({ theme }) => ({
      "& .MuiSwitch-switchBase.Mui-checked": {
        color: "#21578a",
        "&:hover": {
          backgroundColor: alpha("#21578a", theme.palette.action.hoverOpacity),
        },
      },
      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
        backgroundColor: "#21578a",
      },
    }));

    return (
      <div className="input-container">
        {process.env.REACT_APP_LANGUAGE_FORMAT === "toggle" ? (
          <div className="languageSelect">
            <Stack direction="row" spacing={1} alignItems="center">
              <Typography>{getSessionItem("language")}</Typography>
              <GreenSwitch
                size="small"
                value="active"
                onClick={switchClick}
                checked={status}
              />
            </Stack>
          </div>
        ) : (
          ""
        )}

        <Input
          id="messageInput"
          className="input-area"
          inputMode="text"
          autoComplete="off"
          style={{ fontSize: "16px" }}
          onKeyDown={(event) =>
            event.key === "Enter" && handleSanitizeSend("text", typeMessage)
          }
          onPaste={(e) => {
            handleImagePaste(e);
          }}
          //autoSize
          value={typeMessage}
          onChange={(val) => setTypeMessage(val)}
          placeholder={`${t("Message")} ...`}
          aria-label="Type a message"
        />
        <div className="btn-container enter-button">
          <IconButton
            id="send-button"
            className="btn-icon"
            icon="paper-plane"
            aria-label="send"
            onClick={() => {
              handleSanitizeSend("text", typeMessage);
            }}
          />
        </div>
      </div>
    );
  };

  // For navbar setting
  const [iconOpen, setIconOpen] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);

  const open = Boolean(anchorEl);
  const open2 = Boolean(anchorEl2);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setLangSubMenu(false);
    setFontSubMenu(false);
    setDisclaimerSubMenu(false);
  };

  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
    setAnchorEl(null);
    setIconOpen(false);
  };

  const resetChat = () => {
    setAnchorEl(null);
    resetConversation("button");
    messages = [];
    handleSend("welcomeMessage", "welcome");
    // document.getElementById("dropper").style.zIndex = -1;
  };

  const uploadHandler = (e) => {
    setAnchorEl(null);
    let image = e.target.files[0];
    var url = URLObj.createObjectURL(image);
    appendMsg({ type: "image", content: { picUrl: url }, position: "right" });
    if (get_chatType() == "socketIO") {
      socketIO.emit("send-chat-message", { type: "image", message: image });
    }
  };

  return (
    <div
      className={clsx(
        !chatWindowStatus && "hidden-chatWindow",
        chatWindowStatus && "open",
        isMobile ? "mobileChatWindow" : "chatWindow"
      )}
    >
      {!iconOpen && (
        <div className={isMobile ? "mobileChatHeader" : "chatHeader"}>
          <Box className="iconFlexGrow">
            <AppBar position="static" className="chatHeaderBase">
              <Toolbar variant="dense">
                <IconButton1
                  onClick={handleClick}
                  color="inherit"
                  aria-label="Expand more"
                >
                  <MoreVertIcon />
                </IconButton1>
                <Typography
                  className="fontSizeOne iconFlexGrow"
                  // variant="h6"
                  component="div"
                >
                  {lang == "EN"
                    ? env.EN.widgetHeader
                    : env.FR.widgetHeader}
                </Typography>

                {/* Reset Chat Button */}
                {/* <IconButton1
                  className="marginRightTwo"
                  id="restart-button"
                  size="large"
                  edge="start"
                  color="inherit"
                  aria-label="RestartAlt"
                  style={{ marginRight: "5px" }}
                  onClick={resetChat}
                >
                  <RestartAlt />
                </IconButton1> */}

                {/* X Close Button */}
                {isMobile ? (
                  <IconButton1
                    className="marginRightTwo"
                    id="close-button"
                    size="large"
                    edge="start"
                    color="inherit"
                    aria-label="close button"
                    left="4em"
                    style={{ marginRight: "0px" }}
                    onClick={() => {
                      openWindow(false);
                    }}
                  >
                    <CloseIcon />
                  </IconButton1>
                ) : (
                  ""
                )}
                <Menu
                  className="settingMenu"
                  aria-labelledby="settings-menu"
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleClose}
                  disableScrollLock={true}
                  style={{ top: "5px" }}
                >
                  <Box
                    variant="h6"
                    className="settingMenuTitle"
                  //onClick={handleClose}
                  >
                    {t("Settings")}
                  </Box>

                  <Divider />
                  <MenuItem
                    className="MenuItem fontSizeTwo"
                    onClick={downloadTranscript}
                  >
                    {t("Download Transcript")}
                  </MenuItem>

                  <Divider />
                  {process.env.REACT_APP_LANGUAGE_FORMAT === "settings" ? (
                    <MenuItem
                      className="MenuItem fontSizeTwo"
                      id="languageMenuTitle"
                      onClick={openLanguageSubmenu}
                    >
                      <div>{t("Language") + ": "}</div>

                      <div
                        id="languageSelectionDisplay"
                        className="menuSelection"
                      >
                        {lang}
                      </div>
                    </MenuItem>
                  ) : (
                    ""
                  )}

                  {langSubMenu ? (
                    <div className="LanguageSubMenuBox" id="LanguageSubMenuBox">
                      <Divider />
                      <MenuItem
                        className="MenuItem LanguageSubMenu"
                        id="englishSelector"
                        onClick={() => handleLanguagePicker("EN")}
                      >
                        English
                      </MenuItem>

                      <Divider />
                      <MenuItem
                        className="MenuItem LanguageSubMenu"
                        id="frenchSelector"
                        onClick={() => handleLanguagePicker("FR")}
                      >
                        Français
                      </MenuItem>

                      <Divider />
                      <MenuItem
                        className="MenuItem LanguageSubMenu"
                        id="autoSelector"
                        onClick={() => handleLanguagePicker("AUTO")}
                      >
                        Auto Detect
                      </MenuItem>
                    </div>
                  ) : (
                    ""
                  )}

                  {/* Font Size Accessability */}
                  <Divider />

                  <MenuItem
                    className="MenuItem fontSizeTwo"
                    id="fontSizeMenuTitle"
                    onClick={openFontSubmenu}
                  >
                    <div>{t("Font Size") + ": "}</div>
                    <div id="fontSelectionDisplay" className="menuSelection">
                      {t(`${fontSize}`)}
                    </div>
                  </MenuItem>

                  {fontSubMenu ? (
                    <div className="LanguageSubMenuBox" id="LanguageSubMenuBox">
                      <Divider />
                      <MenuItem
                        className="MenuItem LanguageSubMenu fontSizeOne"
                        onClick={() => handleFontPicker("Small")}
                      >
                        {t("Small")}
                      </MenuItem>

                      <Divider />
                      <MenuItem
                        className="MenuItem LanguageSubMenu fontSizeOne"
                        onClick={() => handleFontPicker("Medium")}
                      >
                        {t("Medium")}
                      </MenuItem>

                      <Divider />
                      <MenuItem
                        className="MenuItem LanguageSubMenu fontSizeOne"
                        onClick={() => handleFontPicker("Large")}
                      >
                        {t("Large")}
                      </MenuItem>
                    </div>
                  ) : (
                    ""
                  )}

                  <Divider />
                  <MenuItem
                    className="MenuItem"
                    id="DisclaimerMenuTitle fontSizeTwo"
                    onClick={openDisclaimerSubmenu}
                  >
                    <div>{t("Disclaimer")}</div>
                  </MenuItem>

                  {disclaimerSubMenu ? (
                    <div
                      className="DisclaimerSubMenuBox"
                      id="DisclaimerSubMenuBox"
                    >
                      <Divider />
                      <MenuItem
                        className="MenuItem DisclaimerSubMenu"
                        onClick={() => {
                          setDisclaimerSubMenu(false);
                        }}
                      >
                        <p className="DisclaimerSubMenu">{t("AI Message")}</p>
                      </MenuItem>
                    </div>
                  ) : (
                    ""
                  )}

                  <Divider />
                  <MenuItem
                    className="MenuItem"
                    id="DisclaimerMenuTitle fontSizeTwo"
                    onClick={resetChat}
                  >
                    <div>{t("Reset Chat")}</div>
                  </MenuItem>

                  <Divider />
                  <MenuItem
                    style={{ height: "48px", fontSize: "var(--font-size-3)" }}
                    disabled={true}
                  >
                    &#169;2024 Connex{" "}
                  </MenuItem>
                </Menu>
              </Toolbar>
            </AppBar>
          </Box>

          {/* Language Options */}
          {/* <div>
            <Menu
              anchorEl={anchorEl2}
              id="account-menu"
              open={open2}
              onClose={handleClose2}
              onClick={handleClose2}
              PaperProps={{
                style: {
                  transform: "translateX(-99%) translateY(-38%)",
                  width: "170px",
                  borderRadius: "10px",
                },
              }}
              MenuListProps={{
                style: {
                  padding: 0,
                },
              }}
              disableScrollLock={true}
            >
              <MenuItem
                style={{ justifyContent: "center" }}
                onClick={() => handleLanSelect("FR")}
              >
                French
              </MenuItem>
              <Divider />
              <MenuItem
                style={{ justifyContent: "center" }}
                onClick={() => handleLanSelect("EN")}
              >
                English
              </MenuItem>
            </Menu>
          </div> */}
        </div>
      )}
      <Chat
        Composer={InputContainer}
        messages={messages}
        renderMessageContent={renderMessageContent}
        //quickReplies={quickReplies}
        //onQuickReplyClick={handleQuickReplyClick}
        onSend={handleSend}
      />

      {/* mouse enter event is only triggered if user isn't dragging and drop zone is active */}
      {/* <div
        id="dropper"
        {...getRootProps({ className: "dropzone" })}
        onMouseEnter={() => {
          deactivateDropzone();
        }}
      >
        <input {...getInputProps()} />
      </div> */}
    </div>
  );
}
